import React from 'react'
import ElfsightReviewsWidget from './ElfsightReviewsWidget'
import ElfsightReviewsDynamicWidget from './ElfsightReviewsDynamicWidget'
import {
  getGooglePlaceId,
  getReviewsByProviderAndPlatform,
  hasGoogleReviews
} from '../../../../domain/center'
import {
  THIRD_PARTY_REVIEW_PROVIDERS,
  THIRD_PARTY_REVIEW_PLATFORMS
} from '../../../../domain/center/constants'
import { isNonEmptyObject, isNonEmptyString } from '../../../../utils/checks'

export default function ThirdPartyReviews({ center }) {
  const ReviewsWidget = ReviewsWidgetFactory(center)

  if (ReviewsWidget) {
    return (
      <div
        id="reviews-widget"
        className="mx-auto mb-[64px] max-w-screen-xl px-4 md:px-6 lg:px-8"
      >
        {ReviewsWidget}
      </div>
    )
  }
  return null
}

function ReviewsWidgetFactory(center) {
  const googleElfsightReviews = getReviewsByProviderAndPlatform({
    center,
    provider: THIRD_PARTY_REVIEW_PROVIDERS.ELFSIGHT,
    platform: THIRD_PARTY_REVIEW_PLATFORMS.GOOGLE
  })

  if (isNonEmptyObject(googleElfsightReviews)) {
    return (
      <ElfsightReviewsWidget
        providerId={googleElfsightReviews.provider_id}
        center={center}
      />
    )
  }

  const googlePlaceId = getGooglePlaceId(center)

  if (hasGoogleReviews(center) && isNonEmptyString(googlePlaceId)) {
    return <ElfsightReviewsDynamicWidget center={center} />
  }

  return null
}
